exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-7d0c9639]{display:flex;flex-direction:column;gap:16px}.content .table .field[data-v-7d0c9639]{padding:8px}.content .table .actions[data-v-7d0c9639]{width:1%}.content .btn[data-v-7d0c9639]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.content .has-error[data-v-7d0c9639]{border-color:#dc3545}.content[data-v-7d0c9639]  .date-picker-wrapper>div:first-child{display:flex;flex-direction:row;align-items:center;padding-right:12px}.content[data-v-7d0c9639]  .vdp-datepicker input{height:64px}", ""]);

// exports
